export const RESORT_ALL = 'all'
export const VENUE_ALL = 'all'

export const BOOKING_PAYMENTS_LABELS = [
	'Unpaid',
	'Paid',
	'Partial paid',
	'Over paid',
	'External',
]

export const BOOKING_STATUSES_LABELS = [
	'Unconfirmed',
	'Confirmed',
	'Cancelled',
	'Cancelled (Owner)',
	'Cancelled (Traveler)',
]
